var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.jobs'),"icon":"$files","draggable":true,"layout-path":"dashboard.jobs-card"}},[_c('file-system',{attrs:{"roots":"gcodes","name":"dashboard","dense":"","height":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }